var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',_vm._g({staticClass:"plus-icon__wrapper bg-primary flex items-center justify-center w-10 h-full rounded-r-none rounded-l-lg cursor-pointer",attrs:{"type":"primary","disabled":_vm.disabled}},_vm.$listeners),[_c('font-awesome-icon',{staticClass:"plus-icon__icon text-xl text-primary-content",attrs:{"icon":['fa', 'plus']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }